export default {
    en: {
        title: "All Classes"
    },
    zh: {
        title: "所有课程"
    }
}